import { InteractionType } from '@azure/msal-browser';
import { MsalGuardConfiguration } from '@azure/msal-angular';

import { environment } from '../../../../environments/environment';
import { getDomainHint } from './get-domain-hint';

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: [environment.auth.scope, 'openid', 'profile'],
      extraQueryParameters: {
        domain_hint: getDomainHint(),
      },
    },
  };
}
